<div class="debug-style" *ngIf="form" >
  <div>Detalhes do formulário</div>
  <pre>Form válido: {{ form.valid }}</pre>
  <!--pre>Form submetido: {{ form.submitted }}</pre -->
  <pre>Valores: <br>{{ form.value | json }}</pre>
</div>
